import React, { useEffect } from 'react';
import lostGif from 'assets/images/lost.gif';
import logo from 'assets/images/logo.jpg';
import { Link } from 'react-router-dom';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';
import posthog from 'posthog-js';

export default function Page404({ error }) {
    useEffect(() => {
        if (!error) return;

        try {
            const href = window.location && window.location.href ? window.location.href : 'unknown';
            const key = `__lsgo_teacher_404_ph__:${href}`;
            if (window.sessionStorage && window.sessionStorage.getItem(key) === '1') return;
            window.sessionStorage && window.sessionStorage.setItem(key, '1');

            posthog.capture('page_404_error_rendered', {
                surface: 'teacher',
                href,
                pathname: window.location && window.location.pathname,
                search: window.location && window.location.search,
                referrer: document && document.referrer,
            });
        } catch (e) {
            // ignore analytics failures
        }
    }, [error]);

    return (
        <div
            style={{
                width: '100%',
                height: '100vh',
                background: '#ccc url(' + lostGif + ') no-repeat center bottom',
                backgroundSize: 'cover',
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '500px',
                    margin: '0 auto',
                    padding: 80,
                    backgroundColor: 'rgba(204,204,204,0.8)',
                    textAlign: 'center',
                    borderRadius: 4,
                }}
            >
                <div>
                    <img src={logo} style={{ maxHeight: '140px' }} />
                </div>
                {!error ? (
                    <h3>
                        It seems like you are lost. Go back to <Link to={ROUTES.TEACHER.DASHBOARD.path}>Dashboard</Link>
                    </h3>
                ) : (
                    <h3>
                        Oops. There was an error. Go back to <Link to={ROUTES.TEACHER.DASHBOARD.path}>Dashboard</Link>.
                    </h3>
                )}
            </div>
        </div>
    );
}
